var _path, _path2, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,19.5A19.5,19.5,0,1,1,19.5,0,19.5,19.5,0,0,1,39,19.5Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82,15.89V12.55A2.15,2.15,0,0,1,12,10.47h3.62m0,18.06H12a2.15,2.15,0,0,1-2.21-2.08V23.11M23.35,10.47H27a2.15,2.15,0,0,1,2.21,2.08v3.34m0,7.22v3.34A2.15,2.15,0,0,1,27,28.53H23.35",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.54,
    y1: 14.88,
    x2: 15.54,
    y2: 24.12,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.46,
    y1: 14.88,
    x2: 23.46,
    y2: 24.12,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 15.76,
    x2: 19.5,
    y2: 23.24,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 26.27,
    y1: 17.83,
    x2: 26.27,
    y2: 21.17,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12.73,
    y1: 17.83,
    x2: 12.73,
    y2: 21.17,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.b36a796eb8faa4b59fae5d152b63acf3.svg";
export { ForwardRef as ReactComponent };